import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryTag } from '@common/ts';
import axiosInstanceAnalyze from '@/axios/AxiosInstanceAnalyze';
import { API_ENDPOINTS } from '@/api-endpoints';

export const useMutateApi = <TData, TVariables>(
  mutationFn: (data: TVariables) => Promise<TData>,
  queryKeysToInvalidate?: Array<string | readonly unknown[]>,
  onSuccessCallback?: (data: TData) => void,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: (data) => {
      if (queryKeysToInvalidate && queryKeysToInvalidate.length > 0) {
        queryKeysToInvalidate.forEach((queryKey) => {
          const key = Array.isArray(queryKey) ? queryKey : [queryKey];
          queryClient.invalidateQueries({ queryKey: key });
        });
      }
      if (onSuccessCallback) {
        onSuccessCallback(data);
      }

      return data;
    },
  });
};

/**
 * Delete translations for a specific language in a project
 * This will remove all existing translations and allow retranslation
 */
export const useMutateDeleteTranslation = (projectId?: string) => {
  return useMutateApi(
    ({ language }: { language: string }) =>
      axiosInstanceAnalyze.delete(`${API_ENDPOINTS.RESULTS.GET_LANGUAGES(projectId)}/${language}`),
    [QueryTag.PROJECT_LANGUAGES, QueryTag.QUESTION_TRANSCRIPTS, QueryTag.CONVERSATIONS],
  );
};
